import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { SynchronizeAccountsRequestModel, SynchronizeAccountsResponseModel } from "@/features/accounts/creca/services/synchronize-accounts-model";

export class SynchronizeAccountsApi {
  /**
   * クレカアカウント同期API
   */
  public synchronizeAccounts = async (
    param: SynchronizeAccountsRequestModel
  ): Promise<SynchronizeAccountsResponseModel> => {
    const path = `/api/crecaaccounts/synchronize`;
    const res = await ApiClient.instance.post<SynchronizeAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
